import { createAction } from 'typesafe-actions';

export const removeAllTags = createAction('filters/removeAllTags')<never>();
